import { SelectAttribute } from '../../../types/SelectAttribute';
import { IconArrowUpAndDown } from '../../Icon/IconArrowUpAndDown';

import styles from './Select.module.scss';

import type { FC, ChangeEventHandler } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

export type Props = {
  id: string;
  attributes: SelectAttribute[];
  width: 'default' | 'wide' | 'short';
  value?: string;
  defaultValue?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
};

export type ListProps = {
  attributes: SelectAttribute[];
};

const Options: FC<ListProps> = ({ attributes }) => (
  <>
    {attributes.map((attribute) => (
      <option
        className={styles.option}
        key={attribute.key}
        label={attribute.label}
        value={attribute.value}
      >
        {attribute.label}
      </option>
    ))}
  </>
);

// eslint-disable-next-line max-lines-per-function
export const Select: FC<Props> = ({
  attributes,
  width,
  value,
  defaultValue,
  onChange,
  id,
}) => {
  switch (width) {
    case 'default':
      if (value) {
        return (
          <div className={styles['select-default']}>
            <select
              id={id}
              className={styles.wrap}
              value={value}
              onChange={onChange}
            >
              <Options attributes={attributes} />
            </select>
            <span className={styles['icon-position']}>
              <IconArrowUpAndDown />
            </span>
          </div>
        );
      }

      return (
        <div className={styles['select-default']}>
          <select
            id={id}
            className={styles.wrap}
            defaultValue={defaultValue}
            onChange={onChange}
          >
            <Options attributes={attributes} />
          </select>
          <span className={styles['icon-position']}>
            <IconArrowUpAndDown />
          </span>
        </div>
      );
    case 'wide':
      if (value) {
        return (
          <div className={styles['select-wide']}>
            <select
              id={id}
              className={styles.wrap}
              value={value}
              onChange={onChange}
            >
              <Options attributes={attributes} />
            </select>
            <span className={styles['icon-position']}>
              <IconArrowUpAndDown />
            </span>
          </div>
        );
      }

      return (
        <div className={styles['select-wide']}>
          <select
            id={id}
            className={styles.wrap}
            defaultValue={defaultValue}
            onChange={onChange}
          >
            <Options attributes={attributes} />
          </select>
          <span className={styles['icon-position']}>
            <IconArrowUpAndDown />
          </span>
        </div>
      );
    case 'short':
      if (value) {
        return (
          <div className={styles['select-short']}>
            <select
              id={id}
              className={styles.wrap}
              value={value}
              onChange={onChange}
            >
              <Options attributes={attributes} />
            </select>
            <span className={styles['icon-position']}>
              <IconArrowUpAndDown />
            </span>
          </div>
        );
      }

      return (
        <div className={styles['select-short']}>
          <select
            id={id}
            className={styles.wrap}
            defaultValue={defaultValue}
            onChange={onChange}
          >
            <Options attributes={attributes} />
          </select>
          <span className={styles['icon-position']}>
            <IconArrowUpAndDown />
          </span>
        </div>
      );
    default:
      return assertNever(width);
  }
};
